// extracted by mini-css-extract-plugin
export var scrollArea = "_ps-0";